module.exports = __webpack_public_path__ + "media/images/sports_icons/pool-ball-3875b26493bee8e9c8a2a17086f1f0cc.png";